
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { MessageSquare } from 'lucide-react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className }) => {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl'
  };

  return (
    <Link 
      to="/" 
      className={cn(
        "font-maison tracking-tight transition-all hover:opacity-90 flex items-center", 
        sizeClasses[size],
        className
      )}
    >
      <MessageSquare size={size === 'lg' ? 32 : size === 'md' ? 24 : 16} className="mr-2 text-blue-500" />
      <span className="bg-gradient-to-r from-blue-500 to-blue-600 bg-clip-text text-transparent font-semibold letter-spacing-tight">Chat</span>
      <span className="text-foreground font-light">rix</span>
    </Link>
  );
};

export default Logo;
